<template>
  <div>
    <div class="user-info-wrap">
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="goto('/shop/my')"><i class="icon-arrow-left"></i></div>
        <div class="topbar-main"><h4>个人信息</h4></div>
      </div>
      <div class="user-info-page">
        <div class="info-item" style="height: 7.68rem; line-height: 7.68rem;">
          <a class="item-cell"
            ><div class="item-cell_bd">头像</div>
            <div class="item-cell_ft ft-line">
              <span class="upload-box"
                ><span style="position: relative;"
                  ><div class="m-auto-item memory_photo-item" id="plupload" style="z-index: 1;">
                    <div class="add-item flex flex_center">
                      <div class="add-item-upload add-item-upload2"></div>
                      <div class="add-item-txt"></div>
                    </div>
                  </div>
                  <div
                    id="html5_1frju199q1tom16qrvvsu3k1k3o4_container"
                    class="moxie-shim moxie-shim-html5"
                    style="position: absolute; top: -36px; left: 0px; width: 22px; height: 98px; overflow: hidden; z-index: 0;"
                  >
                    <input
                      id="html5_1frju199q1tom16qrvvsu3k1k3o4"
                      type="file"
                      style="font-size: 999px; opacity: 0; position: absolute; top: 0px; left: 0px; width: 100%; height: 100%;"
                      accept=""
                      tabindex="-1"
                    /></div></span></span
              ><img class="head_img" src="../../../assets/jnt/user.png" /></div
          ></a>
        </div>
        <div class="info-item">
          <a class="item-cell" @click="ncFlag = true"
            ><div class="item-cell_bd">昵称</div>
            <div class="item-cell_ft ft-line"><span>用户339367424</span></div></a
          >
        </div>
        <div class="info-item">
          <a class="item-cell" @click="mobFlag = true"
            ><div class="item-cell_bd">绑定手机号码</div>
            <div class="item-cell_ft ft-line"><span>150****7686</span></div></a
          >
        </div>
      </div>
    </div>
    <div class="mask-wrap" v-if="ncFlag">
      <div class="inner-wrap" style="width: 364px;">
        <div class="inner-head">修改昵称</div>
        <i class="inner-icon-close" @click="ncFlag = false"></i>
        <div class="flex-row">
          <div class="flex-name">昵称:</div>
          <div class="flex-input">
            <input type="text" maxlength="10" class="input-name" v-model="hallInfo.firstName" placeholder="请输入昵称" />
          </div>
        </div>
        <div class="submit-btn" @click="ncFlag = false">确定</div>
      </div>
    </div>
    <div class="mask-wrap" v-if="mobFlag">
      <div class="inner-wrap" style="width: 364px;">
        <i class="inner-icon-close" @click="mobFlag = false"></i
        ><span
          ><div class="inner-head">当前绑定手机号</div>
          <div class="inner-head-mobile">150****7686</div></span
        >
        <div class="style_module_dialog-content style-box">
          <div class="input-group linebottom">
            <div class="inp-content">
              <input
                id="apply_mobile"
                type="number"
                class="inp-content-input"
                placeholder="请输入手机号"
              />
            </div>
          </div>
          <div class="input-group linebottom">
            <input type="text" placeholder="请输入验证码" class="form-control input-code" />
            <div class="input-group-btn">
              <span
                class="btn btn-info btn-captcha"
                style="color: rgb(228, 128, 60); border: 1px solid rgb(228, 128, 60); border-radius: 1.818rem;"
                >获取验证码</span
              >
            </div>
          </div>
        </div>
        <div class="tips">更换后，下次登录请使用新手机号登录</div>
        <div class="submit-btn" @click="mobFlag = false">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'center',
  data() {
    return {
      id: null,
      ncFlag: false,
      mobFlag: false,
      hallInfo: {
        id: null,
        hallCount: null,
        firstName: null,
        firstPhoto: null,
        firstBirthDate: null,
        firstDeathDate: null,
        secondName: null,
        secondPhoto: null,
        secondBirthDate: null,
        secondDeathDate: null,
        content: null,
      },
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    queryHallInfo(){
      var that = this
      this.$queryOne(
        'HallInfo',
        {id: this.id, myId: this.$store.getters.userId},
        ['id,hallCount,firstName,firstPhoto,firstBirthDate,firstDeathDate,secondName,secondPhoto,secondBirthDate,secondDeathDate,content'],
        function(res) {
          that.$fill(that.hallInfo, res['data'])
        }
      )
    }
  },
  created() {
    this.id = this.$route.params.id
    this.queryHallInfo()
  },
  watch: {},
}
</script>

<style>
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}

element.style {
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}
.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/zjt1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.linebottom:after {
  content: '\20';
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #eeeff3;
  -webkit-transform: scaleY(0.5) translate(0, 1px);
  -webkit-transform-origin: 0 0;
  transform: scaleY(0.5) translate(0, 1px);
  transform-origin: 0 0;
}
.user-info-page {
  margin-top: 10px;
  background-color: #fff;
  padding: 0 1.363rem;
  box-sizing: border-box;
}
.user-info-page .info-item {
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  position: relative;
  overflow: hidden;
  font-size: 1.454rem;
  border-bottom: 1px solid #f2f2f2;
}
.user-info-page .info-item .item-cell {
  width: 100%;
  position: relative;
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
a {
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
a {
  background: transparent;
  text-decoration: none;
}
.user-info-page .info-item .item-cell .item-cell_bd {
  -webkit-box-flex: 1;
  flex: 1;
  color: #333;
  font: 1.454rem;
}
.user-info-page .info-item .item-cell .item-cell_ft {
  text-align: right;
  color: #666;
  position: relative;
  padding-right: 2rem;
}
.user-info-page .info-item .item-cell .item-cell_ft .upload-box {
  opacity: 0;
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  text-align: center;
}
.m-auto-item,
.m-auto-item .item-img {
  display: inline-block;
  position: relative;
}
.m-auto-item {
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 33.33%;
  padding: 0 0.5125rem 0.5125rem 0;
}
.m-auto-item .add-item {
  text-align: center;
  border: 1px dashed #999;
  border-radius: 5px;
  padding-bottom: 100%;
  height: 0;
  position: relative;
  display: inline-block;
  width: 100%;
}
.flex_center {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.m-auto-item .add-item .add-item-upload {
  border-radius: 5px;
  border: none;
  display: inline-block;
  position: static;
  margin-bottom: 9px;
  width: 5rem;
  height: 5rem;
  margin-top: 15px;
}
.m-auto-item .add-item .add-item-upload:before {
  width: 4px;
  height: 39.5px;
}
.m-auto-item .add-item .add-item-upload:after,
.m-auto-item .add-item .add-item-upload:before {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #999;
  border-radius: 6px;
}
.m-auto-item .add-item .add-item-upload:after {
  width: 39.5px;
  height: 4px;
}
input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}
.user-info-page .info-item .item-cell .item-cell_ft .head_img {
  width: 5.454rem;
  height: 5.454rem;
  border-radius: 50%;
  z-index: 1;
  opacity: 1;
  object-fit: cover;
}
a img {
  border: 0;
}
.user-info-page .info-item .item-cell .item-cell_ft.ft-line:after {
  content: '';
  display: inline-block;
  width: 0.682rem;
  height: 1.18rem;
  background: url(../../../assets/jnt/jt2.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.mask-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.6);
}
.mask-wrap .inner-wrap {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1.363rem;
  overflow: hidden;
  box-shadow: 0 0 2.363rem 0.363rem hsl(0deg 0% 40% / 10%);
}

element.style {
}
.mask-wrap .inner-wrap .inner-head {
  width: 100%;
  padding: 2.272rem 0 1.818rem;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  font-size: 1.454rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
}

element.style {
}
.mask-wrap .inner-wrap .inner-icon-close {
  width: 1.181rem;
  height: 1.181rem;
  position: absolute;
  right: 1.09rem;
  top: 1.09rem;
  background: url(../../../assets/jnt/c1.png) no-repeat;
  background-size: 100% 100%;
  z-index: 2000;
}
.inner-icon-close {
  height: 15px;
  width: 15px;
  background: url(../../../assets/jnt/c1.png) no-repeat;
  background-size: 100%;
}

element.style {
}
.mask-wrap .inner-wrap .flex-row {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 0 2.272rem;
  height: 4rem;
  line-height: 4rem;
}
.mask-wrap .inner-wrap .flex-row .flex-name {
  width: 8rem;
  height: 2.727rem;
  line-height: 2.727rem;
  display: inline-block;
  font-size: 1.272rem;
  color: #333;
  text-align: center;
}
.mask-wrap .inner-wrap .flex-row .flex-input {
  flex: 1;
  position: relative;
}
.mask-wrap .inner-wrap .flex-row .flex-input .input-name {
  width: 100%;
  height: 2.727rem;
  line-height: 2.727rem;
  display: inline-block;
  outline: 0;
  border: 0;
  font-size: 1.272rem;
  color: #1b1c21;
  text-align: left;
  border-bottom: 1px solid #f7f7f7;
}
.mask-wrap .inner-wrap .submit-btn {
  background: #e4803c;
  color: #fff;
  font-size: 1.272rem;
  cursor: pointer;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  text-align: center;
  border-radius: 2rem;
  margin: 1.363rem;
}
.mask-wrap .inner-wrap .inner-head-mobile {
  font-size: 1.454rem;
  color: #000;
  text-align: center;
  margin: -1rem 0 2rem;
}
.style-box {
  width: 100%;
  padding: 0 2.727rem;
  box-sizing: border-box;
}
.style_module_dialog-content {
  overflow-wrap: break-word;
  font-size: 1rem;
  color: #666;
  max-height: 320px;
  overflow: auto;
  text-align: left;
}

element.style {
}
.style_module_dialog-content .input-group {
  height: 48px;
  border-radius: 4px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 11px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  font-size: 1.2rem;
  position: relative;
}
.input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.style_module_dialog-content .input-group .inp-content {
  display: block;
  line-height: 1.4em;
  height: 1.4em;
  min-height: 1.4em;
  overflow: hidden;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.style_module_dialog-content .input-group .inp-content .inp-content-input {
  display: block;
  height: 100%;
  width: 100%;
  line-height: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-indent: inherit;
  text-transform: inherit;
  text-shadow: inherit;
  border: none;
  text-align: left;
  color: #666;
}

element.style {
}
.style_module_dialog-content .input-group .input-code {
  height: 52px;
  border: none;
  background: 0 0;
  font-size: 1.2rem;
}
.input-group-btn,
.input-group .form-control {
  display: table-cell;
}
.input-group .form-control {
  position: relative;
  z-index: 2;
  float: left;
  width: 100%;
  margin-bottom: 0;
}

element.style {
}
.style_module_dialog-content .input-group .input-group-btn {
  width: auto;
}
.input-group-btn,
.input-group .form-control {
  display: table-cell;
}
.input-group-btn {
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}
.style_module_dialog-content .input-group .input-group-btn .btn-info {
  color: #b26d4e;
}
.style_module_dialog-content .input-group .input-group-btn .btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 1.2rem;
  line-height: 1.42857143;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.mask-wrap .tips {
  font-size: 1.09rem;
  color: #999;
  text-align: left;
  margin-top: 1rem;
  box-sizing: border-box;
  text-align: center;
}
</style>
